import { useTheme } from "../../core/hooks/useTheme.js";
import { useUserQuery } from "../../core/hooks/use-user-query.js";
import { i18n } from "../../../utils/i18n.js";
import { PortalTour } from "../../core/providers/tour.js";
import { useKeycloak } from "../../core/context/keycloak.js";
import { Idioma, IdiomaInfo } from "../../../utils/idioma.js";
import { useCurrentProductStore } from "../../core/hooks/use-current-product-store.js";
import { Content } from "../components/content.js";
import { useEffect } from "react";
import { jsx } from "react/jsx-runtime";
import { I18nProvider } from "@lingui/react";
//#region src/modules/header/ui/index.tsx
var Header = ({ shadowRoot, ...rest }) => {
	const { data: user } = useUserQuery();
	const { keycloak } = useKeycloak();
	useTheme(keycloak.realm, shadowRoot);
	const { setCurrentProduct } = useCurrentProductStore();
	const { currentProduct } = { ...rest };
	useEffect(() => {
		if (currentProduct) setCurrentProduct(currentProduct);
	}, [currentProduct]);
	const idiomaAtual = Idioma[user?.idioma?.id ?? "PT_BR"];
	useEffect(() => {
		i18n.activate(IdiomaInfo[idiomaAtual].language);
	}, [idiomaAtual]);
	return /* @__PURE__ */ jsx(I18nProvider, {
		i18n,
		children: /* @__PURE__ */ jsx(PortalTour, {
			steps: [],
			children: /* @__PURE__ */ jsx(Content, { ...rest })
		})
	});
};
//#endregion
export { Header };
